var map = {
	"./wenti_banner.jpg": "9204",
	"./wenti_banner_en.jpg": "ba25",
	"./wenti_banner_es.jpg": "9e46",
	"./wenti_banner_hk.jpg": "80fc",
	"./wenti_banner_pt.jpg": "b3e3",
	"./wenti_banner_tr.jpg": "125d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5175";